import { BaseEntity, BaseSearchForm } from 'entities'
import { Probe } from './probe'
import { ProductItem } from './product_item'

export type ProtocolVersion = BaseEntity & {
    number?: number
    probes?: Probe[]
    productItem?: ProductItem
    productItemId?: number
    protocolVersionProbes?: ProtocolVersionProbes[]
}

export type ProtocolVersionForm = ProtocolVersion & {
    protocolVersionProbes?: ProtocolVersionProbes[]
}

export type ProtocolVersionSearchForm = BaseSearchForm & {
    name?: string
    id?: string
    onlyQc?: boolean
    productItemId?: number
    isStandardQc?: boolean
}

export type QcType = 'RNA_SPIKE_IN' | 'RT_SPIKE_IN' | 'HK'
export type ProtocolVersionProbes = BaseEntity & {
    probe?: Probe
    probeId?: number
    qcType?: QcType
    minRange?: number
    maxRange?: number
    ctMinRange?: number
    ctMaxRange?: number
    xlcl?: number
    xucl?: number
    rucl?: number
    isNegativeMarker?: boolean
}

export const QC_TYPE = ['RNA_SPIKE_IN', 'RT_SPIKE_IN', 'HK']
export const QC_TYPE_SELECT_ITEMS = QC_TYPE.map((i) => {
    return { label: i, value: i }
})
